import { TFunction } from '@mint-lib/i18n';
import { z } from 'zod';

import { BudgetLimitErrors } from '../../../../constants/recosSettings.js';

const getLimitErrorMessages = (t: TFunction) => ({
  [BudgetLimitErrors.EMPTY_FIELD]: t("Field can't be empty"),
});

export const RecosSettingsSchema = (t: TFunction) =>
  z
    .object({
      isBudgetLimited: z.boolean(),
      budgetReallocationLimits: z
        .object({
          min: z.number().nullable(),
          max: z.number().nullable(),
        })
        .nullable(),
    })
    .superRefine((data, ctx) => {
      if (data.isBudgetLimited) {
        if (!data.budgetReallocationLimits?.min) {
          ctx.addIssue({
            code: 'custom',
            path: ['budgetReallocationLimits', 'min'],
            message: getLimitErrorMessages(t)[BudgetLimitErrors.EMPTY_FIELD],
          });
        }
        if (!data.budgetReallocationLimits?.max) {
          ctx.addIssue({
            code: 'custom',
            path: ['budgetReallocationLimits', 'max'],
            message: getLimitErrorMessages(t)[BudgetLimitErrors.EMPTY_FIELD],
          });
        }
      }
    });
